import { render, staticRenderFns } from "./DomainStatusEdit.vue?vue&type=template&id=430856d0"
import script from "./DomainStatusEdit.vue?vue&type=script&lang=js"
export * from "./DomainStatusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports